import { Medlemskapstype } from '../api/medlemskapAPI';
import styles from './medlemskapType.module.scss';
import { Link } from 'react-router-dom';

function EnkeltmedlemskapLink(props: { medlemskapstyper: Medlemskapstype[] }) {
    const sortedByPrice = props.medlemskapstyper.sort((a, b) => {
        return a.price - b.price;
    });
    const lowestPrice = sortedByPrice[0].price;
    const highestPrice = sortedByPrice[sortedByPrice.length - 1].price;
    return (
        <Link to={'personalia/Enkelt'} className={`${styles.typeContainer} ${styles.typeLink}`}>
            <h2 className={styles.name}>Enkeltmedlemskap</h2>
            <p className={styles.description}>
                Medlemskapet er for én person. Pris settes og justeres etter medlemmets alder.
            </p>
            <div className={styles.priceLineLink}>{lowestPrice + '-' + highestPrice + ' kr'}</div>
            <div className={styles.choose}> Velg medlemskap</div>
        </Link>
    );
}

export default EnkeltmedlemskapLink;
